import React from "react";
import styled from "styled-components";
import { FOOTER_LIST, FOOTER_INFO } from "./data/footerInfo";

const Footer = () => {
  if (window.location.pathname === "/") return null;
  return (
    <FooterContainer>
      <FooterLists>
        {FOOTER_LIST.map((item, index) => (
          <FooterListUrl key={index} href={item.url}>
            <FooterList>{item.list}</FooterList>
          </FooterListUrl>
        ))}
      </FooterLists>
      <FooterInfos>
        {FOOTER_INFO.map((item, index) => (
          <FooterInfo key={index}>{item}</FooterInfo>
        ))}
      </FooterInfos>
    </FooterContainer>
  );
};

export default Footer;

const FooterContainer = styled.div`
  background-color: ${props => props.theme.style.deepGray};
  color: ${props => props.theme.style.white};
  width: 1000px;
  font-size: 18px;
  margin: 0 auto;
  padding: 2rem 0.5em;
  white-space: pre;

  @media screen and (max-width: 1000px) {
    width: 100vw;
    font-size: 16px;
  }

  @media screen and (max-width: 900px) {
    font-size: 15px;
  }

  @media screen and (max-width: 700px) {
    font-size: 14px;
  }

  @media screen and (max-width: 500px) {
    font-size: 13px;
  }

  @media screen and (max-width: 300px) {
    font-size: 2px;
  }

  @media screen and (max-width: 200px) {
    font-size: 6px;
  }
`;

const FooterLists = styled.ul`
  ${props => props.theme.variables.flex("", "center", "center")};
  margin-bottom: 3em;

  @media screen and (max-width: 300px) {
    margin-bottom: 8em;
  }
`;

const FooterListUrl = styled.a`
  &:hover {
    text-decoration: none;
  }
`;

const FooterList = styled.li`
  margin: 0 0.6em;

  @media screen and (max-width: 300px) {
    margin: 0 1.5em;
  }
`;

const FooterInfos = styled.ul`
  color: ${props => props.theme.style.lightGrey};
  text-align: center;
  opacity: 0.5;
`;

const FooterInfo = styled.li`
  margin: 1em 0;

  &:nth-child(6) {
    margin: 3em 0 0;

    @media screen and (max-width: 300px) {
      margin: 8em 0 0;
    }
  }
`;
